import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['product', 'empty'];

    active = {};

    toggle (event) {
        const name = event.target.name.replace('_', '-');

        if (!this.active[name]) {
            this.active[name] = [];
        }

        if (event.target.checked) {
            this.active[name].push(event.target.value);
        } else {
            this.active[name] = this.active[name].filter((v) => v !== event.target.value);
        }

        this.#refresh();
    }

    #refresh () {
        let hasVisible = false;

        this.productTargets.forEach((product) => {
            for (const filter in this.active) {
                if (!this.active[filter].length) {
                    continue;
                }

                if (!product.hasAttribute(`data-filter-${filter}-value`)) {
                    continue;
                }

                if (!this.active[filter].includes(product.getAttribute(`data-filter-${filter}-value`))) {
                    product.style.display = 'none';
                    return;
                }
            }

            hasVisible = true;
            product.style.display = '';
        });

        this.emptyTarget.style.display = hasVisible ? 'none' : 'block';
    }
}
